var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterLightGrayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 9,
    height: 3.26667,
    rx: 0.5,
    fill: "white",
    stroke: "#9296AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3.13379,
    width: 15,
    height: 7.53333,
    rx: 1,
    fill: "white",
    stroke: "#9296AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.4668,
    width: 9,
    height: 7.53333,
    rx: 1,
    fill: "white",
    stroke: "#9296AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 5.29993C11.5 5.00538 11.5799 4.7666 11.6786 4.7666H13.8214C13.9201 4.7666 14 5.00538 14 5.29993C14 5.59449 13.9201 5.83327 13.8214 5.83327H11.6786C11.5799 5.83327 11.5 5.59449 11.5 5.29993Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterLightGrayOutline);
export default __webpack_public_path__ + "static/media/printerLightGrayOutline.bcf521c6000090217123877947e08da9.svg";
export { ForwardRef as ReactComponent };